import { useEffect, useState } from 'react';
import { IApiResponse } from '../interfaces';

interface useApiOptionsProps {
  enabled?: boolean;
  onSuccess?: (res: IApiResponse) => any;
  onError?: (error: Error) => any;
  onFire?: () => void;
}

interface useApiProps {
  name: string;
  fn: () => IApiResponse;
  opts: useApiOptionsProps;
}

export const useMutation = (
  key: string | string[],
  fn: (data?: any) => Promise<IApiResponse>,
  options?: useApiOptionsProps
) => {
  const {
    onSuccess = (res) => res,
    onError = (error) => error,
    onFire = () => null
  } = options;
  const [isLoading, setIsLoading] = useState(false);
  const [isError, seIsError] = useState(false);
  const [data, setData] = useState();

  const mutate = async (data?: any) => {
    try {
      setIsLoading(true);
      onFire()
      const apiRes:Awaited<IApiResponse> = await fn(data);
      setIsLoading(false);
      if (apiRes.status === 200) {
        const resData = apiRes.data;
        const tempData = onSuccess(apiRes);
        setData(tempData);
      } else {
        throw new Error(apiRes.error);
      }
    } catch (error) {
      console.error(error);
      seIsError(true);
      onError(error);
    }
  };

  return {
    data,
    mutate,
    isLoading,
    isError
  };
};
